module.exports = __webpack_public_path__ + "static/media/paypal-normal.85af3aab.png";